module.exports = __webpack_public_path__ + "img/starfilled.656047d7.svg";